<div class="card">
  <div class="card-body pt-1">
    <p class="text-danger font-weight-bold">Top usage</p>
    <div class="row" *ngIf="devices?.length">
      <div
        class="d-flex col-xs-6 col-6 col-md-6 justify-content-between align-items-end"
        style="
          box-shadow: inset 0px 0px 8px -10px #ccc,
            inset 0px -20px 10px -10px #ccc;
        "
      >
        <div
          class="stick"
          id="stick"
          *ngFor="let item of devices"
          [ngStyle]="{
            height: (item.consumption / top) * 100 + '%',
            'background-color': item.color
          }"
        ></div>
      </div>
      <div class="col-xs-6 col-6 col-md-6">
        <div *ngFor="let item of devices">
          <span class="device_name">{{ item.device_name }} </span>
          <p
            [ngStyle]="{ color: item.color }"
            class="mb-0"
            *ngIf="item.consumption"
          >
            ● {{ item.consumption.toFixed(1) }} Units
          </p>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="! devices?.length">
            <p class="text-center font-weight-bold text-warning">No data found...</p>
        </div> -->
    <!-- <div class="row mt-4">
      <div class="col-6">
        <p>
          Uptime:
          <span class="font-weight-bold text-danger" *ngIf="uptime"
            >{{ uptime.toFixed(1) }}%</span
          >
        </p>
      </div>
    </div> -->
  </div>
</div>
